import axios from "axios";
import { EX_END_FULL_LOCATION } from "../enums/departure_location.enum";

export interface SelectOption {
  value: string;
  label: string;
  code?: string;
  searchText?: string;
}

const arrayUniqueByKey = (array, key) => [...new Map(array.map(item => [item[key], item])).values()];

class ListApi {

  getLocations(): Promise<string[]> {
    const apiUrl = "/api/v1/series/country_list";

    return axios.get(apiUrl)
    .then(response => {
      const locations = response.data.countries.map(country => ({id: country, name: country}))
      return Promise.resolve(locations);
    });
  }

  getItineraries(): Promise<string[]> {
    const apiUrl = "/api/v1/series/itinerary_list";

    return axios.get(apiUrl)
    .then(response => {
      const itineraries = response.data.codes.map(code => ({id: code[0], name: code[1]}))
      return Promise.resolve(itineraries);
    });
  }

  getCruiseItineraries(): Promise<string[]> {
    const apiUrl = "/api/v1/series/cruise_itinerary_list";

    return axios.get(apiUrl)
    .then(response => {
      const itineraries = response.data.codes.map(code => ({id: code[0], name: code[1]}))
      return Promise.resolve(itineraries);
    });
  }

  getTitles(): Promise<any[]> {
    const designations = [
      "Miss",
      "Mr",
      "Ms",
      "Mstr",
    ]
    return Promise.resolve(this.strArrToOptions(designations))
  }

  getRoles(): Promise<any[]> {
    return Promise.resolve([
      {value: "private", label: "Private"},
      {value: "corporate", label: "Corporate"},
      {value: "agent", label: "Agent"},
    ])
  }

  getAirlines(): Promise<any[]> {
    return Promise.resolve([
      {value: "low_cost_carrier", label: "Low Cost Carrier"},
      {value: "full_service_carrier", label: "Full Service Carrier"},
      {value: "no_flights_required", label: "No Flights Required"},
    ])
  }

  getGenders(): Promise<any[]> {
    return Promise.resolve([
      {value: "male", label: "Male"},
      {value: "female", label: "Female"},
    ])
  }
  
  getCountries(): Promise<any[]> {
    const apiUrl = "/api/v1/countries";

    return axios.get(apiUrl)
    .then(response => {
      const countries = response.data.data.map(({attributes: {name}}) => ({value: name, label: name}));
      return Promise.resolve(countries);
    });
  }

  getStates(params?): Promise<any[]> {
    const apiUrl = "/api/v1/states";

    return axios.get(apiUrl, {
      params
    })
    .then(response => {
      const states = response.data.map(res => ({value: res, label: res}));
      return Promise.resolve(states);
    });
  }

  getCities(params?): Promise<any[]> {
    const apiUrl = "/api/v1/cities";

    return axios.get(apiUrl, {
      params
    })
    .then(response => {
      const cities = response.data.data.map(({attributes: {name, state, country}}) => ({value: name, label: name, state, country}));
      return Promise.resolve(cities);
    });
  }

  getStatesOptionsByCities(cities){
    const states = cities.map(({state}) => ({value: state, label: state}));
    return arrayUniqueByKey(states, "value") as SelectOption[];
  }

  getBrands(){
    const brands = [{id: 'GD_Standard', value: 'GD Classic'}, {id: 'GD_Signature', value: 'The Signature Tours'}, {id: 'GD_In_Depth', value: 'GD In-Depth'}, {id: 'FS', value: 'FS Holidays'}];
    const cruise_brands = [{id: 'CRUISE', value: 'GD WORLD CRUISE'}, {id: 'GD_FLY_CRUISE', value: 'GD FLY CRUISE'}];
    const options = [
      {
        label: "Brands",
        type: "series",
        options: brands.map(({id, value}) => ({value: id, label: value}))
      },
      {
        label: "Cruise Brands",
        type: "cruise",
        options: cruise_brands.map(({id, value}) => ({value: id, label: value}))
      },
    ];
    return Promise.resolve(options)
  }

  getExEndOptions(){
    const exEnds = ['PEN', 'KUL', 'JHB', 'SIN', 'BKI', 'SZB', 'KCH'].map(ex => ({
      value: ex,
      label: EX_END_FULL_LOCATION[ex] || ex,
      code: ex,
      searchText: `${EX_END_FULL_LOCATION[ex] || ex} ${ex}`
    }));
    return Promise.resolve(exEnds)
  }

  getPaymentChannels(){
    const paymentChannels = [
      {
        id: 1,
        value: "dobw",
        logo: "duitnow.png",
        label: "Online Banking/Wallets",
        bankName: "dobw_banklist",
        fieldLabel: "Bank",
        options: []
      },
      {
        id: 2,
        value: "public_bank_2",
        logo: "master.png",
        label: "Credit/Debit Card",
        bankName: "pbb_banklist",
        fieldLabel: "Card Method",
        options: []
      },
      {
        id: 3,
        value: "fpx_b2c",
        logo: "fpx-new.png",
        label: "B2C (Retail Banking)",
        bankName: "banklist",
        fieldLabel: "Bank",
        options: []
      }
    ];

    return Promise.resolve(paymentChannels)
  }

  getChangeAgentReasons(changeReasons: Record<string, string> = {}){
    const agentChangeReasons = Object.entries(changeReasons || {}).map(([value, label]) => ({ value, label }));

    return Promise.resolve(agentChangeReasons);
  }

  private strArrToOptions(strArr: string[]){
    return strArr.map(str => ({value: str, label: str}));
  }


}

export default ListApi;
